import axios from 'axios'
import { serializeParams } from '../utils/genericUtils'

export default {
  namespaced: true,
  actions: {
    getStudentAuthorizations(_, params) {
      return axios({
        method: 'GET',
        url: `${
          process.env.VUE_APP_URL
        }/checkoutAuthorization/web/students${serializeParams(params)}`,
      })
    },
    getCollegeAuthorizations(_, params) {
      return axios({
        method: 'GET',
        url: `${
          process.env.VUE_APP_URL
        }/checkoutAuthorization/web${serializeParams(params)}`,
      })
    },
    createAuthorizations(_, data) {
      return axios({
        method: 'POST',
        url: `${process.env.VUE_APP_URL}/checkoutAuthorization/web`,
        data,
      })
    },
    editAuthorizations(_, { data, idAuthorization }) {
      return axios({
        method: 'PUT',
        url: `${process.env.VUE_APP_URL}/checkoutAuthorization/web/${idAuthorization}`,
        data,
      })
    },
    getAuthorization(_, idAuthorization) {
      return axios({
        method: 'GET',
        url: `${process.env.VUE_APP_URL}/checkoutAuthorization/web/${idAuthorization}`,
      })
    },
    deleteAuthorization(_, idAuthorization) {
      return axios({
        method: 'DELETE',
        url: `${process.env.VUE_APP_URL}/checkoutAuthorization/web/${idAuthorization}`,
      })
    },
    detailAuthorization(_, { idAuthorization, params }) {
      return axios({
        method: 'GET',
        url: `${
          process.env.VUE_APP_URL
        }/checkoutAuthorization/web/${idAuthorization}/students${serializeParams(
          params
        )}`,
      })
    },
  },
}
